/**
 * Tap-to-answer choices (e.g. "I'm ready" / "Tell me more") are hidden by default
 * for now; add "?choices=on" to the page address to show them. The server's
 * authored choices are unchanged either way: this only decides whether the page
 * draws them, and the player can always speak or type.
 */
export function answerChoicesShown(search: string): boolean {
  return new URLSearchParams(search).get('choices') === 'on';
}
